import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import sensors from "sa-sdk-javascript";
import Exposure from "sa-sdk-javascript/dist/web/plugin/exposure/index.es6";

// 线上神策地址 http://admin-sensorsdata.dadaorg.cn:8106/sa?project=XueersiStore
sensors.init({
  server_url: "https://admin-sensorsdata.dadaorg.cn/sa?project=XueersiStore",
  is_track_single_page: true,
  use_client_time: true,
  send_type: "beacon",
  show_log: true,
  heatmap: {
    clickmap: "default",
    scroll_notice_map: "default",
    loadTimeout: 3000,
    collect_tags: { span: true, img: true, div: true, li: true },
  },
});
sensors.registerPage({
  endpoint: "pc",
});
sensors.quick("autoTrack");
sensors.use(Exposure, {});

createApp(App).use(store).use(router).mount("#app");
